import { render, staticRenderFns } from "./AnswerDialog.vue?vue&type=template&id=34b75059&scoped=true"
import script from "./AnswerDialog.vue?vue&type=script&lang=js"
export * from "./AnswerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b75059",
  null
  
)

export default component.exports